import OBTGroupSelector2 from './OBTGroupSelector2';
export default OBTGroupSelector2;
